enum PaymentStrategyType {
    ADYENV2 = 'adyenv2',
    ADYENV2_GOOGLEPAY = 'googlepayadyenv2',
    AFFIRM = 'affirm',
    AFTERPAY = 'afterpay',
    AMAZON = 'amazon',
    AUTHORIZENET_GOOGLE_PAY = 'googlepayauthorizenet',
    AMAZONPAYV2 = 'amazonpay',
    BARCLAYS = 'barclays',
    BLUESNAPV2 = 'bluesnapv2',
    BOLT = 'bolt',
    CHECKOUTCOM = 'checkoutcom',
    CHECKOUTCOM_APM = 'checkoutcomapm',
    CHECKOUTCOM_SEPA = 'checkoutcomsepa',
    CREDIT_CARD = 'creditcard',
    CHECKOUTCOM_GOOGLE_PAY = 'googlepaycheckoutcom',
    CONVERGE = 'converge',
    CYBERSOURCE = 'cybersource',
    CYBERSOURCEV2 = 'cybersourcev2',
    DIGITALRIVER = 'digitalriver',
    CYBERSOURCEV2_GOOGLE_PAY = 'googlepaycybersourcev2',
    KLARNA = 'klarna',
    KLARNAV2 = 'klarnav2',
    LAYBUY = 'laybuy',
    LEGACY = 'legacy',
    MOLLIE = 'mollie',
    NO_PAYMENT_DATA_REQUIRED = 'nopaymentdatarequired',
    OFFLINE = 'offline',
    OFFSITE = 'offsite',
    PAYPAL = 'paypal',
    PAYPAL_EXPRESS = 'paypalexpress',
    PAYPAL_EXPRESS_CREDIT = 'paypalexpresscredit',
    PAYPAL_COMMERCE = 'paypalcommerce',
    PAYPAL_COMMERCE_CREDIT = 'paypalcommercecredit',
    PAYPAL_COMMERCE_CREDIT_CARD = 'paypalcommercecreditcards',
    PAYPAL_COMMERCE_ALTERNATIVE_METHODS = 'paypalcommercealternativemethods',
    SAGE_PAY = 'sagepay',
    SQUARE = 'squarev2',
    STRIPEV3 = 'stripev3',
    BRAINTREE = 'braintree',
    BRAINTREE_PAYPAL = 'braintreepaypal',
    BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit',
    BRAINTREE_VISA_CHECKOUT = 'braintreevisacheckout',
    BRAINTREE_GOOGLE_PAY = 'googlepaybraintree',
    CHASE_PAY = 'chasepay',
    WE_PAY = 'wepay',
    MASTERPASS = 'masterpass',
    STRIPE_GOOGLE_PAY = 'googlepaystripe',
    SEZZLE = 'sezzle',
    ZIP = 'zip',
}

export default PaymentStrategyType;
